export interface Web3ErrorMessages {
    RESOURCE_NOT_AVAILABLE: string;
    ALREADY_PROCESSING: string;
    USER_DENIED_MESSAGE_SIGNATURE: string;
    USER_REJECTED_THE_REQUEST: string;
    PERSONAL_SIGN_ALREADY_PENDING: string;
    SES_WEAK_MAP_ERROR: string;
    ALREADY_PENDING_FOR_ORIGIN: string;
}

export const defaultWeb3ErrorMessages: Web3ErrorMessages = {
    RESOURCE_NOT_AVAILABLE: 'Requested resource not available',
    ALREADY_PROCESSING: 'Already processing eth_requestAccounts',
    USER_DENIED_MESSAGE_SIGNATURE: 'User denied message signature',
    USER_REJECTED_THE_REQUEST: 'User rejected the request.',
    PERSONAL_SIGN_ALREADY_PENDING: 'Request of type \'personal_sign\' already pending',
    SES_WEAK_MAP_ERROR: 'Invalid value used as weak map key',
    ALREADY_PENDING_FOR_ORIGIN: 'already pending for origin',
};
